import { apiLoadSettings, apiSaveSettings } from "./baseApi"

// Section name matches the AdminAjax action names exactly:
// load_pickup_location_settings / save_pickup_location_settings.
export const apiSavePickupLocationSettings = (data, callback) => {
  apiSaveSettings(data, callback, 'pickup_location')
}

export const apiLoadPickupLocationSettings = (callback) => {
  apiLoadSettings(callback, 'pickup_location')
}
